module.exports = __webpack_public_path__ + "static/media/loadinglogo.8f495d18.PNG";